import { AppAction } from "@core/types/redux.type";
import { ExamAttemptActionType } from "./exam-attempt.type";

export const setCurrentAttempt = (attemptId: string): AppAction => {
  return {
    type: ExamAttemptActionType.SET_CURRENT_ATTEMPT,
    payload: { attemptId },
  };
};

export const clearCurrentAttempt = (): AppAction => {
  return {
    type: ExamAttemptActionType.CLEAR_CURRENT_ATTEMPT,
  };
};
